/** @jsx jsx */

import * as React from "react";
import { jsx } from "@emotion/core";
import buttonStyle from "./buttonStyle";

export enum ButtonTypes {
  PRIMARY = "primary"
}

interface ButtonProps {
  children: string,
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  customStyle?: any,
  theme?: ButtonTypes
}

const Button: React.SFC<ButtonProps> = (props) => {
  return (
    <button type="button" css={buttonStyle(props.theme || ButtonTypes.PRIMARY)} onClick={props.onClick}>{props.children}</button>
  );
}

export default Button;